<div class="dropdown">
  <ng-template *ngTemplateOutlet="content"></ng-template>
</div>
